import { post, get, getFrom } from "@/axios";
import { warehouses } from "@/mock/warehouses";
import menus from "@/mock/menus";

export const authAction = function ({ username, password }) {
    return post(`/customer/users/token?username=${username}&password=${password}`)
}

export const getMenu = function () {
    return get(`/customer/menus/routes`)
}

export const setUerWarehouse = function ({ wareCode }) {
    return post(`/wms/warehouse/switchWarehouse?wareCode=${wareCode}`)
}
export const checkJurisdiction = function () {
    return get(`/customer/users/me`)
}
export const getWarehouseList = function () {
    return get(`/wms/warehouse/warehouseList`)
}

// 客户标记下拉
export const listCustomerTasEnum = function () {
    return post(`/customer/tag/listCustomerTasEnum`)
}
